// extracted by mini-css-extract-plugin
export var button = "Pagination-module--button--v7OB3";
export var firstInRange = "Pagination-module--firstInRange--VogvG";
export var item = "Pagination-module--item--d5mi7";
export var itemText = "Pagination-module--itemText--wnuDB";
export var lastInRange = "Pagination-module--lastInRange--HzwzO";
export var list = "Pagination-module--list--G2YSL";